module.exports = __webpack_public_path__ + "img/bmat_logo_magenta.3e4e9d3b.jpg";